var map = {
	"./headings.scss": 28,
	"./hero.scss": 29,
	"./home-top-background.scss": 30,
	"./inside-top-background.scss": 31,
	"./nav-scroll.scss": 32,
	"./nav.scss": 33,
	"./navbar-callout.scss": 34
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;


//////////////////
// WEBPACK FOOTER
// ./css/site \.scss$
// module id = 27
// module chunks = 0